// extracted by mini-css-extract-plugin
export default {"card":"Member_card__r37uk","media":"Member_media__uolL2","name":"Member_name__pRwAS","about":"Member_about__e4k6x"};